<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="600" persistent @input="closeModal">
      <v-card class="card">
        <v-card-title class="headline accent--text pb-4">
          {{ isShowMode ? 'Просмотр' : isEdit ? 'Редактировать' : 'Добавить' }}
        </v-card-title>
        <v-card-text outlined tile class="border-top">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="gender.name"
                  :disabled="isShowMode"
                  label="Пол"
                  placeholder="Введите пол"
                  @input="$v.gender.name.$touch()"
                  @blur="$v.gender.name.$touch()"
                  :error-messages="errorMessages.name"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn text color="lightGrey" @click="closeModal"> {{ isShowMode ? 'Закрыть' : 'Отмена' }} </v-btn>
          <v-btn
            v-if="!isShowMode"
            :loading="saveBtnLoading"
            :disabled="$v.$invalid || isShowMode"
            color="success"
            text
            @click="saveGender"
          >
            {{ isEdit ? 'Сохранить' : 'Создать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { Gender } from '@/models'
import { setValidateMessages } from '@/scripts/validation'

export default {
  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

  data: () => ({
    gender: new Gender()
  }),

  validations() {
    return {
      gender: {
        name: { required },
      }
    }
  },

  computed: {
    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.gender.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.gender[key])
      })

      return allErrors
    }
  },

  methods: {
    saveGender() {
      this.$emit('saveGender', this.gender)
    },

    resetModal() {
      this.$v.$reset()
      this.gender = new Gender()
    },

    closeModal() {
      this.gender = new Gender()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(val) {
      this.gender = val ? Gender.buildFromAPI(val) : new Gender()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important
}
</style>